/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Benefits_Desc_2Inputs */

const et_benefits_desc_2 = /** @type {(inputs: Benefits_Desc_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole vaja maksta klikitasu ega suuri reklaamieelarved nagu Google Ads või Meta Ads puhul.`)
};

const en_benefits_desc_2 = /** @type {(inputs: Benefits_Desc_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No need to pay per click or maintain large ad budgets like Google Ads or Meta Ads.`)
};

/**
* | output |
* | --- |
* | "No need to pay per click or maintain large ad budgets like Google Ads or Meta Ads." |
*
* @param {Benefits_Desc_2Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const benefits_desc_2 = /** @type {((inputs?: Benefits_Desc_2Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Benefits_Desc_2Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_benefits_desc_2(inputs)
	return en_benefits_desc_2(inputs)
});